import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/Footer.css";

const FOOTER_COLUMNS = [
  {
    title: "PixyQuiz",
    links: [
      { label: "Accueil", to: "/" },
      { label: "Classements", to: "/classement" },
      { label: "FAQ", to: "/faq" },
    ],
  },
  {
    title: "Communaute",
    links: [
      { label: "Photothèque", to: "/suggestions-des-joueurs/" },
      { label: "Forum", to: "/forum" },
      { label: "Équipes", to: "/profile/premium-social" },
      { label: "Battles", to: "/profile/battles" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Contactez-nous", to: "/contact" },
      { label: "Signaler un problème", to: "/contact" },
      { label: "Aide", to: "/faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "CGU", to: "/cgu" },
      { label: "Politique de confidentialité", to: "/politique-confidentialite" },
      { label: "Mentions légales", to: "/mentions-legales" },
      { label: "Cookies", to: "/cookies" },
    ],
  },
];

function FooterLink({ label, to }) {
  return (
    <Link to={to} className="text-sm text-slate-600 transition hover:text-pixy-blue">
      {label}
    </Link>
  );
}

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-emerald-100 bg-[linear-gradient(180deg,_#f8fff8,_#e9f7ff)] text-pixy-ink">
      <div className="mx-auto max-w-screen-2xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid gap-8 border-b border-emerald-100 pb-8 sm:grid-cols-2 xl:grid-cols-[1.15fr_0.85fr_0.85fr_0.85fr_0.85fr]">
          <div className="max-w-sm">
            <div className="text-xs font-semibold uppercase tracking-[0.34em] text-pixy-green">
              PixyQuiz
            </div>
            <h2 className="mt-3 text-2xl font-black text-pixy-ink">PixyQuiz</h2>
            <p className="mt-3 text-sm leading-7 text-slate-600">
              Le monde en images, en temps réel, avec quiz live, communauté et
              progression joueur.
            </p>
          </div>

          {FOOTER_COLUMNS.map((column) => (
            <div key={column.title}>
              <div className="text-sm font-bold uppercase tracking-[0.24em] text-pixy-ink">
                {column.title}
              </div>
              <div className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <FooterLink key={link.label} label={link.label} to={link.to} />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 pt-6 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <div>© {currentYear} PixyQuiz. Tous droits réservés.</div>
          <div className="text-slate-500">
            Expérience quiz multijoueur moderne et responsive.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

